"use strict";

exports.__esModule = true;
exports.SingleSelect = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _VirtualScroller = require("./VirtualScroller");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SelectorButton = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "SingleSelect__SelectorButton",
  componentId: "sc-1abyuwo-0"
})(["max-width:400px;.", "{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-wrap:normal;}"], _core.Classes.BUTTON_TEXT);
var FilterInput = (0, _styledComponents["default"])(_core.InputGroup).withConfig({
  displayName: "SingleSelect__FilterInput",
  componentId: "sc-1abyuwo-1"
})(["z-index:1;"]);
var SingleSelect = exports.SingleSelect = function SingleSelect(props) {
  var _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? "Select" : _props$placeholder,
    _props$filterable = props.filterable,
    filterable = _props$filterable === void 0 ? true : _props$filterable,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? [] : _props$selected,
    renderItemText = props.renderItemText,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$minimal = props.minimal,
    minimal = _props$minimal === void 0 ? false : _props$minimal,
    _props$usePortal = props.usePortal,
    usePortal = _props$usePortal === void 0 ? false : _props$usePortal,
    _props$rightIcon = props.rightIcon,
    rightIcon = _props$rightIcon === void 0 ? _icons.IconNames.DOUBLE_CARET_VERTICAL : _props$rightIcon,
    style = props.style,
    _props$popoverProps = props.popoverProps,
    popoverProps = _props$popoverProps === void 0 ? {} : _props$popoverProps,
    icon = props.icon,
    large = props.large,
    small = props.small,
    className = props.className,
    children = props.children,
    _props$position = props.position,
    position = _props$position === void 0 ? _core.Position.BOTTOM_LEFT : _props$position;
  var inputEl = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(""),
    searchText = _useState[0],
    setSearchText = _useState[1];
  return /*#__PURE__*/_react["default"].createElement(_core.Popover, _extends({
    disabled: disabled,
    usePortal: usePortal,
    enforceFocus: false,
    position: position,
    captureDismiss: true,
    modifiers: {
      preventOverflow: {
        enabled: false
      },
      hide: {
        enabled: false
      },
      arrow: {
        enabled: false
      },
      placement: "bottom-end"
    },
    onOpened: function onOpened() {
      if (inputEl && inputEl.current) {
        inputEl.current.focus();
      }
    }
  }, popoverProps, {
    content: /*#__PURE__*/_react["default"].createElement("div", null, filterable && /*#__PURE__*/_react["default"].createElement(FilterInput, {
      inputRef: inputEl,
      placeholder: "Filter...",
      value: searchText,
      onChange: function onChange(event) {
        return setSearchText(event.target.value);
      },
      leftIcon: _icons.IconNames.SEARCH
    }), /*#__PURE__*/_react["default"].createElement(_VirtualScroller.VirtualScroller, _extends({
      searchText: searchText
    }, props)))
  }), children ? children : /*#__PURE__*/_react["default"].createElement(SelectorButton, {
    "data-testid": "Selector.selectorButton",
    style: style,
    minimal: minimal,
    large: large,
    small: small,
    className: className,
    icon: icon,
    rightIcon: rightIcon,
    text: selected.length > 0 ? renderItemText(selected[0]) : placeholder,
    disabled: disabled
  }));
};